<template>
    <div>
        <el-popover
            v-if="actions.length"
            v-model="visible"
            placement="top"
            trigger="hover"
            popper-class="p-0 ov-hidden"
        >
            <div class="flex-column">
                <CompassLink
                    :label="action.label"
                    type="secondary"
                    class="wp-10 my-2"
                    :class="{ 'mt-2': index === 0, 'mb-2': index === actions.length - 1 }"
                    v-for="(action, index) in actions"
                    :key="index"
                    @click="action.action"
                />
            </div>
            <template #reference>
                <CompassButton
                    :label="mainAction.label"
                    type="secondary"
                    @click="mainAction.action"
                    dropdown
                />
            </template>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        mainAction: {
            type: Object,
            required: true,
        },
        actions: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            visible: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.icon-chevron-up {
    transition: all 0.3s ease;
}
</style>
